import offices from './offices'
import roles from './roles'
import activities from './activities'
import engineersList from './engineers-list'
import certificateCategories from './certificate-categories'
import certificateStatus from './certificate-status'
import productsInCertificate from './products-in-certificate'
import source from './source'
import departments from './departments'
import allTaskManagments from './all-task-managments'
import assignList from './assign-list'
import productList from './products-list'
import reports from './reports'
import payroll from './payroll'
import mainCertificate from './main-certificate'

export default {
  namespaced: true,
  modules: {
    offices,
    roles,
    activities,
    engineersList,
    certificateCategories,
    certificateStatus,
    productsInCertificate,
    source,
    departments,
    allTaskManagments,
    assignList,
    productList,
    reports,
    payroll,
    mainCertificate,
  },
}
